class Slider {

  constructor() {
    this.listeners();
  }

  updateAccessibility(el) {
    const slides = el.querySelectorAll('.splide__slide');
    const isNav = el.getAttribute('data-slider-isnavigation') === 'true';

    if (isNav) return;

    slides.forEach(slide => {
      const isHidden = slide.getAttribute('aria-hidden') === 'true';

      if (isHidden) {
        slide.setAttribute('inert', '');
      } else {
        slide.removeAttribute('inert');
      }
    });
  }

  listeners() {
    const sliders = document.querySelectorAll('.js-slider');

    sliders.forEach((el) => {
      this.createSlider(el);

      let pending = false;

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.attributeName === "aria-hidden") {

            if (pending) return;
            pending = true;

            requestAnimationFrame(() => {
              this.updateAccessibility(el);
              pending = false;
            });

            break;
          }
        }
      });

      observer.observe(el, {
        subtree: true,
        attributes: true,
        attributeFilter: ["aria-hidden"],
      });
    });

    document.addEventListener('asyncSlider:ready', () => {
      const asyncSliders = document.querySelectorAll('.js-async-slider');
      const cartRecommendationsSliders = document.querySelectorAll('.js-cart-recommendations-slider');

      asyncSliders.forEach((el) => this.createSlider(el));
      cartRecommendationsSliders.forEach((el) => this.createSlider(el));
    });

    document.addEventListener('fakeVariant:loaded', () => {
      document.querySelectorAll('.js-product-slider').forEach((el) => {
        this.createSlider(el);
      });
    });

    document.addEventListener('modalContent:ready', () => {
      document.querySelectorAll('.js-modal-slider').forEach((el) => {
        this.createSlider(el, true);
      });
    });
  }

  createSlider(el, modalSlider) {
    let primarySlider;
    let secondarySlider;
    let current;
    let sliderNav;
    let thumbnails;
    const sliderId = el.id;
    const isProductSlider = el.classList.contains('site-slider--product-main-gallery');

    let hasInitiaAccessibilityRun = false;

    if (el.getAttribute('data-slider-sync-to')){
      sliderNav = document.querySelector(el.getAttribute('data-slider-sync-to'));

      secondarySlider = new Splide(sliderNav, this.configuration(sliderNav));
      primarySlider = new Splide(el, this.configuration(el));

      primarySlider.sync(secondarySlider);

    } else {
      primarySlider = new Splide(el, this.configuration(el));
    }

    primarySlider.mount();

    if (!hasInitiaAccessibilityRun) {
      this.updateAccessibility(el);
      hasInitiaAccessibilityRun = true;
    }

    primarySlider.on('mounted moved updated', () => {
      this.updateAccessibility(el);
    });

    if (secondarySlider) {
      secondarySlider.mount();

      if (!hasInitiaAccessibilityRun) {
        this.updateAccessibility(sliderNav);
        hasInitiaAccessibilityRun = true;
      }

      secondarySlider.on('mounted moved updated', () => {
        this.updateAccessibility(sliderNav);
      });
    }

    document.querySelectorAll('[data-slider-isnavigation="true"] .splide__list').forEach((sliderList) => {
      sliderList.setAttribute('role', 'tablist');
      sliderList.setAttribute('aria-orientation', 'vertical');

      const isHidden = !!sliderList.closest('[aria-hidden="true"]');

      sliderList.querySelectorAll('.splide__slide').forEach((slide) => {
        slide.setAttribute('role', 'tab');

        const isActive = slide.classList.contains('is-active');

        slide.setAttribute('aria-selected', isActive ? 'true' : 'false');
        slide.setAttribute('tabindex', isActive ? '0' : '-1');

        if (isHidden) {
          slide.setAttribute('inert', '');
        } else {
          slide.removeAttribute('inert');
        }
      });
    });

    const slider = document.querySelector(`#${sliderId}`);
    const videos = document.querySelectorAll('.js-slider-video');
    const slides = slider.querySelectorAll('.js-slide');
    const sliderVideos = slider.querySelectorAll('.js-slider-video');
    const sliderPagination = slider.getAttribute('data-product-main-slider') ? slider.querySelector('.splide__pagination') : '';

    if (sliderNav) {
      thumbnails = sliderNav.querySelectorAll('.js-slider-thumbnail');
  
      thumbnails.forEach((el, index) => {
        el.addEventListener('click', () => {
          primarySlider.go(index);
        });
      });
    }

    if (sliderPagination) {
      const sliderPaginationItems = sliderPagination.querySelectorAll('li > button');
      
      slides.forEach((el, index) => {
        if (el.getAttribute('data-video-slide')) {          
          sliderPaginationItems[index].innerHTML = window.icons.play;
        }
      });
    }

    primarySlider.on('moved', () => {
      if (slider.getAttribute('data-slider-type') !== 'loop') {
        if (getSlides(slider).final.visible) {
          nextButtonState(slider, 'disable');
          primarySlider.go(getSlides(slider).firstVisible.index);
        } else {
          nextButtonState(slider, 'enable');
        }
      }

      if (thumbnails) {
        const thumbnail = thumbnails[primarySlider.index];

        thumbnails.forEach((el) => {
          el.classList.remove('active');
        });
        
        if (thumbnail) {
          if (current) {
            current.classList.remove('active');
          }
  
          thumbnail.classList.add( 'active' );
          current = thumbnail;
        }
      }

      if (!isProductSlider) return;

      sliderVideos.forEach((el) => {
        el.pause();
      });

      const activeSlide = slider.querySelectorAll('.site-slider__slide.splide__slide.is-active');
      var unactiveEmbedVideos;
      var player;

      if (slider.querySelectorAll('.site-slider__slide.splide__slide:not(.is-active)').length > 0) {
        unactiveEmbedVideos = Array.from(slider.querySelectorAll('.site-slider__slide.splide__slide:not(.is-active)'))
          .filter((slide) => slide.querySelectorAll('.js-slider-embed-video').length > 0)
          .map((wrapper) => wrapper.querySelectorAll('.js-slider-embed-video')[0]);
      }

      if (activeSlide[0] && activeSlide[0].querySelectorAll('.js-slider-video')[0]) {
        activeSlide[0].querySelectorAll('.js-slider-video')[0].play();
      } else if (activeSlide[0] && activeSlide[0].querySelectorAll('.js-slider-embed-video')[0]) {
        let videoIframe = activeSlide[0].querySelectorAll('.js-slider-embed-video')[0];

        player = new Vimeo.Player(videoIframe);
        player.play();
      } else {
        document.querySelectorAll('.js-slider-embed-video').forEach(video => {
          player = new Vimeo.Player(video);
          player.pause();
        });
      }
    });

    if (isProductSlider) {
      const initialActiveSlide = slider.querySelector('.site-slider__slide.splide__slide.is-active');
      const initialVideo = initialActiveSlide && initialActiveSlide.querySelector('.js-slider-video');

      if (initialVideo) {
        initialVideo.muted = true;
        const playAttempt = initialVideo.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(() => {});
        }
      }
    }

    function getSlides(slider) {
      const slides = slider.querySelectorAll('.splide__slide');
      const finalSlide = slides[slides.length - 1];
      let firstVisible = { index: 0 };

      for(let i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-visible')) {
          firstVisible.index = i;
          break;
        }
      }

      return {
        firstVisible,
        final: {
          visible: finalSlide && finalSlide.classList.contains('is-visible')
        }
      }
    }

    function nextButtonState(slider, state) {
      const nextArrow = slider.querySelector('.splide__arrow--next');

      if (nextArrow) {
        if (state === 'enable') {
          nextArrow.classList.remove('disabled');
        } else if (state === 'disable') {
          nextArrow.classList.add('disabled');
        }
      }
    }

    if (slider.getAttribute('data-product-main-slider')) {
      document.addEventListener('slider:go', (e) => {
        const index = e.detail.index;
        const targetSliders = e.detail.targetSliders;
        let goTo = false;
  
        targetSliders.forEach((el) => {
          if (el.id == slider.id) {
            goTo = true
          }
        });
  
        if (goTo) {
          primarySlider.go(index - 1);
        }
      });
    }

    if (Shopify.designMode) {
      document.addEventListener('sliders:destroy', () => {
        primarySlider.destroy();

        if (secondarySlider) {
          secondarySlider.destroy();
        }
      });
    }

    if (modalSlider) {
      document.addEventListener('modalContent:destroy', () => {
        primarySlider.destroy();

        if (secondarySlider) {
          secondarySlider.destroy();
        }
      }, { once: true });
    }
  }

  configuration(el){
    let breakpointsObject = {
      519: {},
      767: {},
      979: {},
      1279: {},
      1399: {},
      1599: {}
    },
    breakpointsList = [],
    sliderPerPage = 0,
    sliderPerPageXs = el.getAttribute('data-slider-perpage-xs'),
    sliderPerPagePh = el.getAttribute('data-slider-perpage-ph'),
    sliderPerPageSm = el.getAttribute('data-slider-perpage-sm'),
    sliderPerPageMd = el.getAttribute('data-slider-perpage-md'),
    sliderPerPageLg = el.getAttribute('data-slider-perpage-lg'),
    sliderPerPageXl = el.getAttribute('data-slider-perpage-xl'),
    sliderPerMoveXs = el.getAttribute('data-slider-permove-xs'),
    sliderPerMovePh = el.getAttribute('data-slider-permove-ph'),
    sliderPerMoveSm = el.getAttribute('data-slider-permove-sm'),
    sliderPerMoveMd = el.getAttribute('data-slider-permove-md'),
    sliderPerMoveLg = el.getAttribute('data-slider-permove-lg'),
    sliderPerMoveXl = el.getAttribute('data-slider-permove-xl'),
    sliderGapSm = el.getAttribute('data-slider-gap-xs'),
    sliderPhOnly = el.getAttribute('data-slider-ph-only'),
    sliderSmOnly = el.getAttribute('data-slider-sm-only'),
    sliderPadding = el.getAttribute('data-slider-padding'),
    sliderPaddingObject = {};

    if (sliderPerPageXs) {
      breakpointsObject['519'].perPage = sliderPerPageXs;
    }

    if (sliderPerPagePh) {
      breakpointsObject['767'].perPage = sliderPerPagePh;
    }

    if (sliderPerPageSm) {
      breakpointsObject['979'].perPage = sliderPerPageSm;
    }

    if (sliderPerPageMd) {
      breakpointsObject['1279'].perPage = sliderPerPageMd;
    }

    if (sliderPerPageLg) {
      breakpointsObject['1399'].perPage = sliderPerPageLg;
    }

    if (sliderPerPageXl) {
      breakpointsObject['1599'].perPage = sliderPerPageXl;
    }

    if (sliderPerMoveXs) {
      breakpointsObject['519'].perMove = sliderPerMoveXs;
    }

    if (sliderPerMovePh) {
      breakpointsObject['767'].perMove = sliderPerMovePh;
    }

    if (sliderPerMoveSm) {
      breakpointsObject['979'].perMove = sliderPerMoveSm;
    }

    if (sliderPerMoveMd) {
      breakpointsObject['1279'].perMove = sliderPerMoveMd;
    }
    
    if (sliderPerMoveLg) {
      breakpointsObject['1399'].perMove = sliderPerMoveLg;
    }

    if (sliderPerMoveXl) {
      breakpointsObject['1599'].perMove = sliderPerMoveXl;
    }

    if (sliderGapSm) {
      breakpointsObject['979'].gap = sliderGapSm;
    }

    if (sliderPhOnly) {
      breakpointsObject['767'].destroy = false;
    }

    if (sliderSmOnly) {
      breakpointsObject['979'].destroy = false;
    }

    if (el.getAttribute('data-slider-perpage')){
      sliderPerPage = el.getAttribute('data-slider-perpage');
    } else {
      sliderPerPage = 1;
    }

    if (sliderPadding) {
      const splitPadding = sliderPadding.split(",");

      splitPadding.forEach(function (value, index) {
        switch(index) {
          case 0:
            Object.assign(sliderPaddingObject, {top: value});
            break;
          case 1:
            Object.assign(sliderPaddingObject, {right: value});
            break;
          case 2:
            Object.assign(sliderPaddingObject, {bottom: value});
          break;
          case 3:
            Object.assign(sliderPaddingObject, {left: value});
          break;
        }
      });
    } else {
      sliderPaddingObject = false;
    }

    let conf = {
      type: el.getAttribute('data-slider-type') || "carousel",
      rewind: el.getAttribute('data-slider-rewind') || false,
      speed: el.getAttribute('data-slider-speed') || 400,
      rewindSpeed: el.getAttribute('data-slider-rewindspeed') || 0,
      waitForTransition: el.getAttribute('data-slider-waitfortransition') || true,
      width: el.getAttribute('data-slider-width') || 0,
      height: el.getAttribute('data-slider-height') || 0,
      fixedWidth: el.getAttribute('data-slider-fixedwidth') || 0,
      fixedHeight: el.getAttribute('data-slider-fixedheight') || 0,
      heightRatio: el.getAttribute('data-slider-heightratio') || 0,
      autoWidth: el.getAttribute('data-slider-autowidth') || false,
      autoHeight: el.getAttribute('data-slider-autoheight') || false,
      perPage: el.getAttribute('data-slider-perpage') || 0,
      perMove: el.getAttribute('data-slider-permove') || 0,
      clones: el.getAttribute('data-slider-clones') || 0,
      start: el.getAttribute('data-slider-start') || 0,
      focus: el.getAttribute('data-slider-focus') || 0,
      gap: el.getAttribute('data-slider-gap') || 0,
      padding: sliderPaddingObject,
      easing: el.getAttribute('data-slider-easing') || 'cubic-bezier(.42,.65,.27,.99)',
      arrows: el.getAttribute('data-slider-arrows') || false,
      pagination: el.getAttribute('data-slider-pagination') || false,
      autoplay: el.getAttribute('data-slider-autoplay') || false,
      interval: el.getAttribute('data-slider-interval') || 5000,
      pauseOnHover: el.getAttribute('data-slider-pauseonhover') || true,
      pauseOnFocus: el.getAttribute('data-slider-pauseonfocus') || true,
      resetProgress: el.getAttribute('data-slider-resetprogress') || true,
      lazyload: el.getAttribute('data-slider-lazyload') || false,
      preloadPages: el.getAttribute('data-slider-preloadpages') || 1,
      keyboard: el.getAttribute('data-slider-keyboard') || 'global',
      drag: el.getAttribute('data-slider-drag') || true,
      wheel: el.getAttribute('data-slider-wheel') === 'true',
      releaseWheel: el.getAttribute('data-slider-releasewheel') === 'true',
      flickPower: el.getAttribute('data-slider-flickpower') || 600,
      flickMaxPages: el.getAttribute('data-slider-flickmaxpages') || 1,
      direction: el.getAttribute('data-slider-direction') || 'ltr',
      cover: el.getAttribute('data-slider-cover') || false,
      slideFocus: el.getAttribute('data-slider-slidefocus') || true,
      isNavigation: el.getAttribute('data-slider-isnavigation') || false,
      trimSpace: el.getAttribute('data-slider-trimspace') || true,
      updateOnMove: el.getAttribute('data-slider-updateonmove') || false,
      destroy: el.getAttribute('data-slider-disabled') || false,
      noDrag: el.getAttribute('data-slider-nodrag') || null,
      breakpoints: breakpointsObject
    }
    return conf;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Slider();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    document.dispatchEvent(new Event('sliders:destroy'));
    new Slider();
    document.dispatchEvent(new Event('asyncSlider:ready'));
  });

  document.addEventListener('shopify:block:deselect', () => {
    document.dispatchEvent(new Event('sliders:destroy'));
    new Slider();
    document.dispatchEvent(new Event('asyncSlider:ready'));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const hiddenFakeVariantSelects = document.querySelectorAll(
    '.js-fake-variants-select[aria-hidden="true"]'
  );

  hiddenFakeVariantSelects.forEach((select) => {
    select.setAttribute('tabindex', '-1');
    select.setAttribute('disabled', 'disabled');
  });

});